/**
 * GPU 源码 <pre> 滚到高亮行。
 * 必须用相对 pre 的位置，不能用 el.offsetTop（offsetParent 经常是外层容器）。
 */
function shouldDeferGpuSourceScroll({ windowsDecodeLoading }) {
  return !!windowsDecodeLoading;
}

function computeGpuSourceScrollTop({ preClientHeight, relativeTop, elHeight }) {
  if (!preClientHeight) {
    return null;
  }
  return Math.max(0, relativeTop - preClientHeight / 2 + (elHeight || 0) / 2);
}

function scrollGpuSourceHighlight(pre, el) {
  if (!pre || !el || pre.clientHeight <= 0) {
    return false;
  }
  const preRect = pre.getBoundingClientRect();
  const elRect = el.getBoundingClientRect();
  if (preRect.height <= 0) {
    return false;
  }
  const relativeTop = elRect.top - preRect.top + pre.scrollTop;
  const next = computeGpuSourceScrollTop({
    preClientHeight: pre.clientHeight,
    relativeTop,
    elHeight: elRect.height || el.offsetHeight || 0,
  });
  if (next == null) {
    return false;
  }
  pre.scrollTop = next;
  return true;
}

function formatGpuWindowsDecodeError(raw) {
  const s = String(raw || '');
  if (/ZIP\s*文件损坏|HTTP\s*400/i.test(s)) {
    return 'ZIP 文件损坏';
  }
  return s;
}

module.exports = {
  shouldDeferGpuSourceScroll,
  computeGpuSourceScrollTop,
  scrollGpuSourceHighlight,
  formatGpuWindowsDecodeError,
};
